import styled from "styled-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { i18nFilter } from "app/filters/i18nFilter";
import { SWReactIcons } from "@similarweb/icons";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const CtaWrapper = styled(CenteredFlexRow)`
    background-color: ${rgba(colorsPalettes.blue[400], 0.1)};
    height: 40px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
`;

const StyledSIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.indigo[300]} !important;
    }
`;

const Text = styled.span`
    ${mixins.setFont({
        $size: 14,
        $weight: 700,
        $color: colorsPalettes.indigo[300],
        $family: "'DM Sans'",
    })};
    margin-left: 6px;
`;

const i18n = i18nFilter();

export const UpgradeCta = () => (
    <CtaWrapper>
        <StyledSIcon
            size="sm"
            iconName={"sparkles"}
        />
        <Text>{i18n("digitalsuite.homepage.tile.upgrade.cta")}</Text>
    </CtaWrapper>
);
